<template>
  <v-btn
    v-bind="$attrs"
    :style="{
      minWidth: '97px',
      height: '50px',
      background: `${
        submit ? '#000B8D' : 'white'
      }  0% 0% no-repeat padding-box`,
      border: `3px solid ${submit ? '#000B8D' : '#707070'}`,
      borderRadius: '25px',
      color: submit ? 'white' : 'black',
      ...$attrs.style
    }"
    v-on="$listeners"
    ><slot></slot>
  </v-btn>
</template>

<script>
export default {
  name: "NextBtn",

  props: ["submit"],

  mounted() {
    // console.log(this.submit);
  }
};
</script>
